import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Catches any render crash so the user sees a recoverable message instead of a black screen.
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(err) {
    try { if (window.gtag) window.gtag('event', 'render_error', { app: 'bizzali-finder', msg: String(err && err.message).slice(0, 120) }); } catch (e) {}
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#0A1230', color: '#FAFBFC', fontFamily: 'Rubik,sans-serif', textAlign: 'center', padding: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
          <p style={{ fontSize: 16, marginBottom: 20, maxWidth: 360, lineHeight: 1.6 }}>
            Niečo sa pokazilo. Skús stránku načítať znova.<br />Something went wrong. Please reload the page.
          </p>
          <button onClick={() => window.location.reload()} style={{ background: '#47D1C2', color: '#0A1230', border: 'none', padding: '14px 28px', borderRadius: 9, fontWeight: 700, fontSize: 16, cursor: 'pointer', fontFamily: 'Rubik,sans-serif' }}>
            Znova načítať / Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
